import React from 'react';
import { Field } from '@truvity/widget__forms';
import { ReadonlyField } from '@truvity/widget__forms-mui-theme';

export const ReadonlyNumericStringField = (props: Field<number | undefined>) => <ReadonlyField {...props} />;
